// extracted by css-extract-rspack-plugin
export default {"root":"root-BkAXzO","content":"content-t99JTO"};